import * as Types from '../../../types/schema.generated';

import gql from 'graphql-tag';
import { AccountProfileEditorTableStaffFragmentDoc } from './AccountProfileEditorTable.generated';
import * as VueApolloComposable from '@vue/apollo-composable';
import * as VueCompositionApi from 'vue';
export type ReactiveFunction<TParam> = () => TParam;
export type SettingsPageAccountViewQueryVariables = Types.Exact<{ [key: string]: never; }>;


export type SettingsPageAccountViewQuery = { __typename?: 'Query', viewer: { __typename?: 'Viewer', staff: { __typename?: 'Staff', guid: string, email: string, name?: string | null, profile: { __typename?: 'StaffProfile', avatar?: any | null } } } };

export type ChangePasswordWithLoggedInMutationVariables = Types.Exact<{
  password: Types.Scalars['String']['input'];
}>;


export type ChangePasswordWithLoggedInMutation = { __typename?: 'Mutation', changePasswordWithLoggedIn: { __typename?: 'ChangePasswordWithLoggedInPayload', success: boolean } };

export type IssueStaffAvatarImageUploadUrlMutationVariables = Types.Exact<{ [key: string]: never; }>;


export type IssueStaffAvatarImageUploadUrlMutation = { __typename?: 'Mutation', issueStaffAvatarImageUploadUrl: { __typename?: 'IssueStaffAvatarImageUploadUrlPayload', uploadURL: string } };

export type UpdateStaffProfileMutationVariables = Types.Exact<{
  input: Types.UpdateStaffProfileInput;
}>;


export type UpdateStaffProfileMutation = { __typename?: 'Mutation', updateStaffProfile: { __typename?: 'UpdateStaffProfileSuccessPayload', staff: { __typename?: 'Staff', guid: string, email: string, profile: { __typename?: 'StaffProfile', avatar?: any | null } } } };


export const SettingsPageAccountViewDocument = gql`
    query SettingsPageAccountView {
  viewer {
    staff {
      guid
      email
      ...AccountProfileEditorTableStaff
    }
  }
}
    ${AccountProfileEditorTableStaffFragmentDoc}`;

/**
 * __useSettingsPageAccountViewQuery__
 *
 * To run a query within a Vue component, call `useSettingsPageAccountViewQuery` and pass it any options that fit your needs.
 * When your component renders, `useSettingsPageAccountViewQuery` returns an object from Apollo Client that contains result, loading and error properties
 * you can use to render your UI.
 *
 * @param options that will be passed into the query, supported options are listed on: https://v4.apollo.vuejs.org/guide-composable/query.html#options;
 *
 * @example
 * const { result, loading, error } = useSettingsPageAccountViewQuery();
 */
export function useSettingsPageAccountViewQuery(options: VueApolloComposable.UseQueryOptions<SettingsPageAccountViewQuery, SettingsPageAccountViewQueryVariables> | VueCompositionApi.Ref<VueApolloComposable.UseQueryOptions<SettingsPageAccountViewQuery, SettingsPageAccountViewQueryVariables>> | ReactiveFunction<VueApolloComposable.UseQueryOptions<SettingsPageAccountViewQuery, SettingsPageAccountViewQueryVariables>> = {}) {
  return VueApolloComposable.useQuery<SettingsPageAccountViewQuery, SettingsPageAccountViewQueryVariables>(SettingsPageAccountViewDocument, {}, options);
}
export function useSettingsPageAccountViewLazyQuery(options: VueApolloComposable.UseQueryOptions<SettingsPageAccountViewQuery, SettingsPageAccountViewQueryVariables> | VueCompositionApi.Ref<VueApolloComposable.UseQueryOptions<SettingsPageAccountViewQuery, SettingsPageAccountViewQueryVariables>> | ReactiveFunction<VueApolloComposable.UseQueryOptions<SettingsPageAccountViewQuery, SettingsPageAccountViewQueryVariables>> = {}) {
  return VueApolloComposable.useLazyQuery<SettingsPageAccountViewQuery, SettingsPageAccountViewQueryVariables>(SettingsPageAccountViewDocument, {}, options);
}
export type SettingsPageAccountViewQueryCompositionFunctionResult = VueApolloComposable.UseQueryReturn<SettingsPageAccountViewQuery, SettingsPageAccountViewQueryVariables>;
export const ChangePasswordWithLoggedInDocument = gql`
    mutation changePasswordWithLoggedIn($password: String!) {
  changePasswordWithLoggedIn(password: $password) {
    success
  }
}
    `;

/**
 * __useChangePasswordWithLoggedInMutation__
 *
 * To run a mutation, you first call `useChangePasswordWithLoggedInMutation` within a Vue component and pass it any options that fit your needs.
 * When your component renders, `useChangePasswordWithLoggedInMutation` returns an object that includes:
 * - A mutate function that you can call at any time to execute the mutation
 * - Several other properties: https://v4.apollo.vuejs.org/api/use-mutation.html#return
 *
 * @param options that will be passed into the mutation, supported options are listed on: https://v4.apollo.vuejs.org/guide-composable/mutation.html#options;
 *
 * @example
 * const { mutate, loading, error, onDone } = useChangePasswordWithLoggedInMutation({
 *   variables: {
 *     password: // value for 'password'
 *   },
 * });
 */
export function useChangePasswordWithLoggedInMutation(options: VueApolloComposable.UseMutationOptions<ChangePasswordWithLoggedInMutation, ChangePasswordWithLoggedInMutationVariables> | ReactiveFunction<VueApolloComposable.UseMutationOptions<ChangePasswordWithLoggedInMutation, ChangePasswordWithLoggedInMutationVariables>> = {}) {
  return VueApolloComposable.useMutation<ChangePasswordWithLoggedInMutation, ChangePasswordWithLoggedInMutationVariables>(ChangePasswordWithLoggedInDocument, options);
}
export type ChangePasswordWithLoggedInMutationCompositionFunctionResult = VueApolloComposable.UseMutationReturn<ChangePasswordWithLoggedInMutation, ChangePasswordWithLoggedInMutationVariables>;
export const IssueStaffAvatarImageUploadUrlDocument = gql`
    mutation issueStaffAvatarImageUploadUrl {
  issueStaffAvatarImageUploadUrl {
    uploadURL
  }
}
    `;

/**
 * __useIssueStaffAvatarImageUploadUrlMutation__
 *
 * To run a mutation, you first call `useIssueStaffAvatarImageUploadUrlMutation` within a Vue component and pass it any options that fit your needs.
 * When your component renders, `useIssueStaffAvatarImageUploadUrlMutation` returns an object that includes:
 * - A mutate function that you can call at any time to execute the mutation
 * - Several other properties: https://v4.apollo.vuejs.org/api/use-mutation.html#return
 *
 * @param options that will be passed into the mutation, supported options are listed on: https://v4.apollo.vuejs.org/guide-composable/mutation.html#options;
 *
 * @example
 * const { mutate, loading, error, onDone } = useIssueStaffAvatarImageUploadUrlMutation();
 */
export function useIssueStaffAvatarImageUploadUrlMutation(options: VueApolloComposable.UseMutationOptions<IssueStaffAvatarImageUploadUrlMutation, IssueStaffAvatarImageUploadUrlMutationVariables> | ReactiveFunction<VueApolloComposable.UseMutationOptions<IssueStaffAvatarImageUploadUrlMutation, IssueStaffAvatarImageUploadUrlMutationVariables>> = {}) {
  return VueApolloComposable.useMutation<IssueStaffAvatarImageUploadUrlMutation, IssueStaffAvatarImageUploadUrlMutationVariables>(IssueStaffAvatarImageUploadUrlDocument, options);
}
export type IssueStaffAvatarImageUploadUrlMutationCompositionFunctionResult = VueApolloComposable.UseMutationReturn<IssueStaffAvatarImageUploadUrlMutation, IssueStaffAvatarImageUploadUrlMutationVariables>;
export const UpdateStaffProfileDocument = gql`
    mutation updateStaffProfile($input: UpdateStaffProfileInput!) {
  updateStaffProfile(input: $input) {
    ... on UpdateStaffProfileSuccessPayload {
      staff {
        guid
        email
        profile {
          avatar
        }
      }
    }
  }
}
    `;

/**
 * __useUpdateStaffProfileMutation__
 *
 * To run a mutation, you first call `useUpdateStaffProfileMutation` within a Vue component and pass it any options that fit your needs.
 * When your component renders, `useUpdateStaffProfileMutation` returns an object that includes:
 * - A mutate function that you can call at any time to execute the mutation
 * - Several other properties: https://v4.apollo.vuejs.org/api/use-mutation.html#return
 *
 * @param options that will be passed into the mutation, supported options are listed on: https://v4.apollo.vuejs.org/guide-composable/mutation.html#options;
 *
 * @example
 * const { mutate, loading, error, onDone } = useUpdateStaffProfileMutation({
 *   variables: {
 *     input: // value for 'input'
 *   },
 * });
 */
export function useUpdateStaffProfileMutation(options: VueApolloComposable.UseMutationOptions<UpdateStaffProfileMutation, UpdateStaffProfileMutationVariables> | ReactiveFunction<VueApolloComposable.UseMutationOptions<UpdateStaffProfileMutation, UpdateStaffProfileMutationVariables>> = {}) {
  return VueApolloComposable.useMutation<UpdateStaffProfileMutation, UpdateStaffProfileMutationVariables>(UpdateStaffProfileDocument, options);
}
export type UpdateStaffProfileMutationCompositionFunctionResult = VueApolloComposable.UseMutationReturn<UpdateStaffProfileMutation, UpdateStaffProfileMutationVariables>;